import { Component, OnInit } from '@angular/core';
import { SttTableComponent } from '../../../../shared/components/stt-table/stt-table.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CustomersAddEditComponent } from '../customers-add-edit/customers-add-edit.component';
import { CustomerModel } from '../../../../shared/entities/customer.model';
import { ConfirmationService, MessageService, PrimeNGConfig } from "primeng/api";
import { ValidationMessageService } from '../../../../shared/services/base/validation-message-handle';
import { finalize } from 'rxjs/operators';
import { CustomerService } from '../../../../shared/services/app/customer.service';

@Component({
    selector: 'app-customers-actions-table',
    templateUrl: './customers-actions-table.component.html',
    styleUrls: ['./customers-actions-table.component.scss']
})

export class CustomersActionsTableComponent implements OnInit {

    public data: any;
    public table: SttTableComponent;
    public ref: DynamicDialogRef;
    public loading = true;

    constructor(
        public dialogService: DialogService,
        public confirmationService: ConfirmationService,
        public primengConfig: PrimeNGConfig,
        public itemService: CustomerService,
        public messageService: MessageService,
        private validationMessageService: ValidationMessageService,
    ) {

    }

    ngOnInit(): void {
    }

    setParams(entity: CustomerModel): void {
        this.data = entity;
    }

    setTableReference(table: SttTableComponent): void {
        this.table = table;
    }


    showDialog() {
        this.ref = this.dialogService.open(CustomersAddEditComponent, {
            header: 'Modificare client',
            width: '70%',
            contentStyle: { 'max-height': '70vh' },
            baseZIndex: 10000,
            closeOnEscape: false,
            data: this.data,
        });

        this.ref.onClose.subscribe((customer: CustomerModel) => {
            if (customer) {
                this.table.refresh();
            }
        });
    }

    confirm() {
        this.confirmationService.confirm({
            header: 'Confirmare stergere Client',
            message: 'Sunteti sigur ca doriti sa stergeti acest Client?',
            key: 'deleteCustomer',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Da',
            rejectLabel: 'Nu',
            acceptButtonStyleClass: 'p-button-md p-button-success',
            rejectButtonStyleClass: 'p-button-md p-button-danger',
            accept: () => {
                this.deleteItem(this.data.uid);
            },
            reject: () => {
                this.confirmationService.close();
                this.table.refresh();
            }
        });
    }

    deleteItem(uid: string){
        this.itemService.delete(uid)
            .pipe(finalize(() => {this.loading = false;this.table.refresh();}))
            .subscribe((response: any) => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Clientul a fost sters cu success!'
                });
            });
    }
}
